(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Expandable Search Functionality
  document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.getElementById('searchToggle');
    const searchContainer = document.getElementById('searchContainer');
    const searchInput = document.getElementById('searchInput');

    if (searchToggle && searchContainer) {
      const searchWrapper = searchToggle.parentElement;
      const localizationWrapper = document.querySelector('.desktop-localization-wrapper');
      
      // Toggle search on icon click
      searchToggle.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const isActive = searchContainer.classList.contains('active');
        
        if (isActive) {
          // Close search
          searchContainer.classList.remove('active');
          searchToggle.classList.remove('active');
          searchWrapper.classList.remove('search-active');
          searchInput.value = '';
          if (localizationWrapper) {
            localizationWrapper.style.opacity = '1';
            localizationWrapper.style.pointerEvents = 'auto';
          }
        } else {
          // Open search
          searchContainer.classList.add('active');
          searchToggle.classList.add('active');
          searchWrapper.classList.add('search-active');
          if (localizationWrapper) {
            localizationWrapper.style.opacity = '0';
            localizationWrapper.style.pointerEvents = 'none';
          }
          setTimeout(() => searchInput.focus(), 100);
        }
      });

      // Prevent closing when clicking inside search container
      searchContainer.addEventListener('click', function(e) {
        e.stopPropagation();
      });

      // Close search when clicking outside
      document.addEventListener('click', function(event) {
        if (searchContainer.classList.contains('active')) {
          searchContainer.classList.remove('active');
          searchToggle.classList.remove('active');
          searchWrapper.classList.remove('search-active');
          searchInput.value = '';
          if (localizationWrapper) {
            localizationWrapper.style.opacity = '1';
            localizationWrapper.style.pointerEvents = 'auto';
          }
        }
      });

      // Close search on ESC key
      document.addEventListener('keydown', function(event) {
        if (event.key === 'Escape' && searchContainer.classList.contains('active')) {
          searchContainer.classList.remove('active');
          searchToggle.classList.remove('active');
          searchWrapper.classList.remove('search-active');
          searchInput.value = '';
          if (localizationWrapper) {
            localizationWrapper.style.opacity = '1';
            localizationWrapper.style.pointerEvents = 'auto';
          }
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-banner"] && !Shopify.designMode) return;
  try {
    
  // Make sure the track width is correct for smooth infinite scroll
  document.addEventListener("DOMContentLoaded", function() {
    const track = document.querySelector(".moving-banner__track");
    if(track){
      const trackWidth = track.scrollWidth / 2;
      track.style.width = track.scrollWidth + "px";
    }
  });

  } catch(e) { console.error(e); }
})();
})();
